// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleGroup_root__aCsmx","switchContainer":"ToggleGroup_switchContainer__WD3tH","option":"ToggleGroup_option__F8PUQ","optionActive":"ToggleGroup_optionActive__8RLD2"};